module.exports = __webpack_public_path__ + "img/iconYeWuFenLiaoJianCe.4e2f0257.svg";